import { enableProdMode } from '@angular/core';
import { platformBrowserDynamic } from '@angular/platform-browser-dynamic';

import { AppModule } from './app/app.module';
import { environment } from './environments/environment';

if (environment.production) {
  enableProdMode();
}

// @ts-ignore - platformBrowserDynamic is deprecated but required for NgModule-based apps
platformBrowserDynamic().bootstrapModule(AppModule, {
  // Security: Remove Angular version from HTML to prevent information disclosure
  ngZoneEventCoalescing: true,
  ngZoneRunCoalescing: true
})
  .then((moduleRef) => {
    // Security: Remove ng-version attribute from all elements
    const appRoot = document.querySelector('app-root');
    if (appRoot) {
      removeNgVersion(appRoot);
    }
  })
  .catch(err => console.error(err));

/**
 * Recursively removes ng-version attributes from elements
 * This prevents Angular version disclosure in production
 */
function removeNgVersion(element: Element): void {
  // Remove from current element
  if (element.hasAttribute('ng-version')) {
    element.removeAttribute('ng-version');
  }
  
  // Remove from all child elements
  Array.from(element.children).forEach(child => {
    removeNgVersion(child);
  });
  
  // Set up a MutationObserver to catch dynamically added elements
  if (environment.production) {
    const observer = new MutationObserver((mutations) => {
      mutations.forEach((mutation) => {
        mutation.addedNodes.forEach((node) => {
          if (node.nodeType === 1) { // Element node
            const el = node as Element;
            if (el.hasAttribute('ng-version')) {
              el.removeAttribute('ng-version');
            }
          }
        });
      });
    });
    
    observer.observe(element, {
      childList: true,
      subtree: true,
      attributes: false
    });
  }
}
